import { useContext, useEffect, useMemo } from "react";
import { InteractionType, RedirectRequest, SilentRequest } from "@azure/msal-browser";
import { useIsAuthenticated, useMsalAuthentication } from "@azure/msal-react";
import { ConfigurationContext } from "../Configuration";
import { getScopes } from "../../../API/Authorization";

export function useAuthentication(): boolean {
  const config = useContext(ConfigurationContext);
  const requestConfig: SilentRequest | RedirectRequest = useMemo(() => ({ ...getScopes(config) }), [config]);
  const { login, error } = useMsalAuthentication(InteractionType.Silent, requestConfig);

  useEffect(() => {
    if (error == null) {
      return;
    }

    login(InteractionType.Redirect, requestConfig);
  }, [error, login, requestConfig]);

  return useIsAuthenticated();
}
